/*@ngInject*/
export default function logProviderDecorator($provide) {
    $provide.decorator('$log', decorator);

    /*@ngInject*/
    function decorator($delegate) {
        let globalLoggingLevel = LOG_LEVELS.LOG;
        let logMethodEnabled = true;

        const configureMethod = (originalMethod, level) =>
            function (...args) {
                if (globalLoggingLevel <= level) {
                    originalMethod.apply(this, args);
                }
            };

        const originalLog = $delegate.log;
        const originalDebug = $delegate.debug;
        const originalInfo = $delegate.info;
        const originalWarn = $delegate.warn;
        const originalError = $delegate.error;

        $delegate.log = configureMethod(originalLog, LOG_LEVELS.LOG || (logMethodEnabled ? 10 : LOG_LEVELS.LOG));
        $delegate.trace = configureMethod(originalLog, LOG_LEVELS.TRACE);
        $delegate.debug = configureMethod(originalDebug, LOG_LEVELS.DEBUG);
        $delegate.info = configureMethod(originalInfo, LOG_LEVELS.INFO);
        $delegate.warn = configureMethod(originalWarn, LOG_LEVELS.WARN);
        $delegate.error = configureMethod(originalError, LOG_LEVELS.ERROR);

        $delegate.setLoggingLevel = function (level) {
            if (typeof level !== 'number' || level < LOG_LEVELS.LOG || level > LOG_LEVELS.ERROR) {
                throw Error(`log.decorator: Invalid logging level: ${level}. Possible values are 0..5 or are listed in LOG_LEVELS constant.`);
            }

            globalLoggingLevel = level;
        };

        $delegate.setLogFunctionEnabled = function(enabled) {
            logMethodEnabled = enabled;
        };



        return $delegate;
    }
}

/**
 * @type {Object}
 * @property {number} LOG Log logging level
 * @property {number} TRACE Trace logging level
 * @property {number} DEBUG Debug logging level
 * @property {number} INFO Info logging level
 * @property {number} WARN Warn logging level
 * @property {number} ERROR Error logging level
 *
 * @description
 * Logging levels constant
 */
export const LOG_LEVELS = Object.defineProperties({}, {
    LOG: {
        value: 0
    },
    TRACE: {
        value: 1
    },
    DEBUG: {
        value: 2
    },
    INFO: {
        value: 3
    },
    WARN: {
        value: 4
    },
    ERROR: {
        value: 5
    }
});